import axios from "axios";
// import { debounce } from "lodash";
import debounce from "lodash/debounce";
import { Trello } from "../../../../types/my-trello-types";
import isLocalStorageAvailable from "../local-storage-helper";

const API_KEY = process.env.API_KEY;

export default function _getRestApi(
  t: Trello.PowerUp.IFrame
): Trello.PowerUp.RestApi {
  if (isLocalStorageAvailable()) {
    // note: It seems that without Localstorage or cookies, when using t.getRestApi() the board button would not appear at all,
    // hence we need the "backupRestApi"
    return t.getRestApi();
  } else {
    return backupRestApi(t);
  }
  // return backupRestApi(t)
}

function backupRestApi(trelloIframe: Trello.PowerUp.IFrame) {
  const t = trelloIframe;

  function clearToken() {
    return t
      .remove("organization", "private", "token")
      .then(() => t.remove("board", "private", "token"));
  }

  function getToken(): Promise<string | undefined> {
    return t.get("organization", "private", "token").then((token) => {
      if (!token) {
        return t.get("board", "private", "token");
      } else {
        return token;
      }
    });
  }

  async function isAuthorized() {
    const token = await getToken();
    if (!token) {
      return false;
    }
    const isAuthorized = await isAuthorizedViaRest(t, token);
    // console.log("IS???", isAuthorized)
    return !!isAuthorized;
  }

  // https://developer.atlassian.com/cloud/trello/power-ups/client-library/t-authorize/
  async function authorize(opt: { scope: string }) {
    const oauthUrl =
      "https://trello.com/1/authorize?expiration=never" +
      `&name=${encodeURIComponent(process.env.APP_NAME as string)}&scope=${opt.scope}&key=${process.env.API_KEY}&callback_method=fragment` +
      `&return_url=${encodeURIComponent(window.location.origin + "/authorize")}`;

    // const tokenLooksValid = function (token) {
    //   return /^[0-9a-f]{64}$/.test(token);
    // };

    const authorizeOpts = {
      height: 680,
      width: 580,
      // Removed validation since Trello can no-longer guarantee their structure. Jireh Lo thinks this might be the issue for some users that prevents them from authorizing: 
      // https://trello-lovers.slack.com/archives/C026C50TFK3/p1771601343769289?thread_ts=1771414966.877819&cid=C026C50TFK3, https://developer.atlassian.com/cloud/trello/changelog/#CHANGE-770
      // validToken: tokenLooksValid,
    };

    return t
      .authorize(oauthUrl, authorizeOpts)
      .then(function (token) {
        // AIDEV-NOTE: triggered by window.opener.authorize (in authorizationComplete page)
        return t.set("organization", "private", "token", token).catch(() => {
          return t.set("board", "private", "token", token);
        });
      })
      .then(function () {
        // now that the token is stored, we can close this popup
        // you might alternatively choose to open a new popup
        return t.closePopup();
      });
  }

  return {
    getToken,
    clearToken,
    isAuthorized,
    authorize,
    isBackup: true,
  };
}

const isAuthorizedViaRest = debounce(
  async (t: Trello.PowerUp.IFrame, token: string) => {
    // console.log("isAuthorizedViaRest")
    const x = await axios
      .get(
        `https://api.trello.com/1/members/${t.getContext().member}/?key=${API_KEY}&token=${token}`
      )
      .catch((err) => {
        console.error(err);
      });
    return !!x?.data;
  },
  500,
  { leading: true }
);
